import { Injectable } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { createStore, select, withProps } from '@ngneat/elf';
import { type ColorTheme } from './darkmode.service';

export const darkmodeStore = createStore({ name: 'darkmode' }, withProps<{ darkmode: ColorTheme }>({ darkmode: 'system' }));

@Injectable({ providedIn: 'root' })
export class DarkmodeRepository {
    public readonly mode = toSignal(darkmodeStore.pipe(select(state => state.darkmode)), { initialValue: 'system' });

    public setMode(darkmode: ColorTheme): void {
        darkmodeStore.update(state => ({ ...state, darkmode }));
    }
}
